// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1coeb","inner":"Footer_inner__2lf98"};